export const filterSymfonyWdt = (context) => (envelope) => {
    if (context.applicationVersion === "dev" && envelope.baseType === "RemoteDependencyData") {
        const data = envelope.baseData;
        if (data && data.name && data.name.indexOf("/_wdt/") !== -1) {
            return false;
        }
    }
};
